import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["pax", "price", "total"]

    connect() {
        this.update()
    }

    update() {
        const pax = parseFloat(this.paxTarget.value || 0)
        const price = parseFloat(this.priceTarget.value || 0)
        const total = (isNaN(pax) || isNaN(price)) ? 0 : pax * price
        this.totalTarget.textContent = this.formatCurrency(total)
    }

    formatCurrency(value) {
        try {
            return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value)
        } catch (e) {
            return `${value.toFixed(2)} €`
        }
    }
}